export default "__VITE_ASSET__DyvT97Lo__"